import gql from 'graphql-tag'

import {query} from '../helpers/apollo'
import axios from '../helpers/axios'

import {SimpleMedia} from './fragment'

const debug = false

export const searchSection = function(params={}){
	if(debug) console.log('[API]', 'searchSection', params)

	let limit = params.limit || 200
	let skip = params.skip || 0

	return query({
		fetchPolicy: 'network-only',
		variables: {
			query: params.query || '',
			_event: params._event || '',
			limit,
			skip: limit * skip,
		},
		query: gql`
			query($limit:Int, $skip:Int, $query:String, $_event:String){
			  searchSection(limit:$limit, skip:$skip, query:$query, _event:$_event){
			    total
			    limit
			    skip 
			    data{ 
			      _id
			      name
			      _event
			      event{
			        name
			      }
			      logoMedia{
		          ...SimpleMedia
		        }
            filmsCount
			    }
			  }
		  }
		  ${SimpleMedia}
		`
	})
		.then(res => res.data.searchSection)
		.catch(err => console.log('🔥 GRAPHQL', err))

}

export const getSection = function(_id){
	if(debug) console.log('[API]', 'getSection', {_id})

	return query({
		fetchPolicy: 'network-only',
		variables: {
			_id
		},
		query: gql`
			query($_id:String!){
		    getSectionById(_id:$_id){
		      _id
		      _event
		      name
		      logo
		      logoMedia{
		        ...SimpleMedia
		      }
		      years{
		        _id
		        year
		        logo
		        logoMedia{
		          ...SimpleMedia
		        }
		      }
		    }
			}
			
			${SimpleMedia}
		`
	})
		.then(res => res.data.getSectionById)
		.catch(err => console.log('🔥 GRAPHQL', err))
}

export const saveSection = async function(data){
	if(debug) console.log('[API]', 'saveSection', data)

	return (data._id
			? axios.post(`/section/${data._id}`, data)
			: axios.put(`/section`, data)
	)
		.then(res => res.data)

}

export const removeSection = function(_id){
	if(debug) console.log('[API]', 'removeSection', _id)

	return axios.delete(`/section/${_id}`)
		.then(res => res.data)

}
